import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Route, CanLoad} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services';
import {map, take} from 'rxjs/operators';
import {MediaMatcher} from '@angular/cdk/layout';

@Injectable(
  { providedIn: 'root' }
)
export class AuthGuard implements CanActivate {
  mobileQuery: MediaQueryList;
  constructor(
    private authService: AuthService,
    private media: MediaMatcher,
    private router: Router) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    const url: string = state.url;
    return this.checkLogin(url);
  }


  // canLoad(route: Route): Observable<boolean>  {
  //   const url = `/${route.path}`;
  //   return this.checkLogin(url);
  // }

  checkLogin(url: string): Observable<boolean>  {
    return this.authService.isAuthenticated.pipe(take(1), map( isAuth => {
        if (isAuth) {
          return true;
        }

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;

        // Navigate to the login page with extras
        // if (this.mobileQuery.matches) {
        //   this.router.navigate(['/auth']);
        // } else {
        //   this.router.navigate(['/auth/login']);
        // }
        this.router.navigate(['/auth']);

        return false;
      })
    );
  }

}
